import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

export type TBarrierForm = {
  barrierCodeId: number
  hoursLost: number
  wasCausedByPreviousShift: boolean
  comment?: string | undefined
}

export function useBarrierForm() {
  function getResolvedBarrierSchema(isCreating: boolean) {
    const validationSchema = z.object({
      barrierCodeId: z.number(),
      hoursLost: z
        .union([z.string(), z.number()])
        .transform((val) =>
          String(val).length === 0 ? '' : val === '0' ? 0 : Number(val),
        )
        .refine((val) => typeof val !== 'string', {
          message: 'Please, add the hour lost for this barrier',
        })
        .refine((val) => Number(val) >= 0, {
          message: 'Value must be greater than or equal to 0',
        }),

      wasCausedByPreviousShift: z.boolean(),
      comment: isCreating
        ? z.string().min(1, { message: 'Please add comments to the barrier' })
        : z.string().optional(),
    })

    return zodResolver(validationSchema)
  }

  return { getResolvedBarrierSchema }
}
